import { render, staticRenderFns } from "./modalEditarValores.vue?vue&type=template&id=97e75c16&"
import script from "./modalEditarValores.vue?vue&type=script&lang=js&"
export * from "./modalEditarValores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports